import { ComponentProps, FC } from 'react'
import { IconWrapper } from '../wrapper'

export const IconPlayLight: FC<ComponentProps<typeof IconWrapper>> = props => {
  const { size = 20, color = 'currentColor' } = props
  return (
    <IconWrapper {...props} size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 2.5L16.6667 10L5 17.5L5 2.5Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  )
}
